<mat-chip-set>
    @for (item of items(); track item) {
        <mat-chip
            #chipTooltip="matTooltip"
            removable
            [matTooltip]="getName(item)"
            [class.st-staff-id-list-multiple-chip-max-width-long]="asCustomField() && internalValue()?.length === maxItemsToShow()"
            [class.st-staff-id-list-multiple-chip-max-width-short]="asCustomField() && internalValue()?.length > maxItemsToShow()"
            [class.st-staff-id-list-multiple-chip-max-width]="asCustomField()"
            [disabled]="disabled()"
            (removed)="remove(item)">
            {{ getName(item) }}
            <button
                matChipRemove
                [attr.aria-label]="'remove ' + item"
                [disabled]="disabled()">
                <mat-icon>close</mat-icon>
            </button>
            <st-avatar
                matChipAvatar
                small
                [userId]="item" />
        </mat-chip>
    }
    @if (shouldShowUsersAsTooltip()) {
        <mat-chip
            #tooltip="matTooltip"
            class="st-staff-id-list-multiple-chip-max-width st-staff-id-list-multiple-chip-max-width-short"
            [matTooltip]="usersAsTooltip()"
            [matMenuTriggerFor]="listDropDownMenu"
            [disabled]="disabled()"
            (menuOpened)="onMenuOpened()">
            {{ usersAsTooltipChip() }}
        </mat-chip>
    }
    <button
        *ngIf="!disabled()"
        mat-button
        class="st-staff-id-list-multiple-button"
        listDropDownMenu
        [class.st-staff-id-list-multiple-button-valid]="(required() && internalValue() && internalValue()?.length === 0) || !internalValue()"
        [class.st-staff-id-list-multiple-button-required]="required()"
        [matMenuTriggerFor]="listDropDownMenu"
        [disabled]="disabled()"
        (menuOpened)="onMenuOpened()"
        (menuClosed)="valueChanged()">
        <span
            [class.st-staff-id-list-multiple-button-label]="asCustomField()"
            [class.st-staff-id-list-multiple-button-label-long]="asCustomField && internalValue()?.length === maxItemsToShow()"
            [class.st-staff-id-list-multiple-button-label-short]="asCustomField && internalValue()?.length > maxItemsToShow()">
            {{ label() || placeholder() }}
        </span>
        <mat-icon>add</mat-icon>
    </button>
</mat-chip-set>

<mat-menu
    #listDropDownMenu="matMenu"
    class="st-staff-id-list-multiple-menu">
    <form
        st-click-stop-propagation
        class="st-staff-id-list-multiple-form"
        [dir]="dir">
        <mat-form-field
            appearance="fill"
            subscriptSizing="dynamic"
            class="st-staff-id-list-multiple-form-search">
            <mat-icon matPrefix>search</mat-icon>
            <input
                #searchBox
                matInput
                [placeholder]="searchLabel()"
                [formControl]="staffFilter" />
        </mat-form-field>
        <mat-selection-list
            hideSingleSelectionIndicator="true"
            st-click-stop-propagation
            multiple="false"
            [ngModel]="internalValue()"
            (selectionChange)="onSelectionChange($event)">
            <mat-list-option
                *ngFor="let userId of filteredOptions | async"
                [value]="userId">
                <st-avatar
                    matListItemAvatar
                    big
                    class="st-staff-id-list-multiple-form-avatar"
                    [userId]="userId" />
                <div matListItemTitle>{{ getName(userId) }}</div>
                <div matListItemLine>{{ getEmail(userId) }}</div>
            </mat-list-option>
        </mat-selection-list>
    </form>
</mat-menu>
